import { useRef } from "react";
import { Link } from "react-router-dom";
import { animes } from "@/mocks/anime";

const latestIds = [
  "oshi-no-ko",
  "haikyuu-s4",
  "blue-lock",
  "mushoku-s2",
  "tgcf",
  "ling-cage",
  "dungeon-meshi",
  "frieren",
];

export default function LatestUpdates() {
  const trackRef = useRef<HTMLDivElement>(null);
  const latest = latestIds
    .map((id) => animes.find((item) => item.id === id))
    .filter((item): item is (typeof animes)[number] => Boolean(item));

  const scrollBy = (direction: number) => {
    trackRef.current?.scrollBy({ left: direction * 420, behavior: "smooth" });
  };

  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
        <div className="flex flex-col gap-4">
          <div className="mb-6 flex items-end justify-between gap-4">
            <div>
              <span className="mb-2 flex items-center gap-1.5 font-label text-[11px] uppercase tracking-[0.2em] text-primary-600">
                <i className="ri-heart-3-fill text-xs" />
                Latest update
              </span>
              <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">最新动漫更新</h2>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                本周更新最勤的八部作品，连载中的剧集会在详情页同步集数状态。
              </p>
            </div>
            <div className="hidden shrink-0 items-center gap-2 md:flex">
              <Link
                to="/category?status=连载中"
                className="mr-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                查看连载中
              </Link>
              <button
                type="button"
                onClick={() => scrollBy(-1)}
                aria-label="向左滚动"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-arrow-left-s-line text-lg" />
              </button>
              <button
                type="button"
                onClick={() => scrollBy(1)}
                aria-label="向右滚动"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-arrow-right-s-line text-lg" />
              </button>
            </div>
          </div>

          <div
            ref={trackRef}
            className="scrollbar-hide -mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 md:mx-0 md:px-0"
          >
            {latest.map((anime) => (
              <Link
                key={anime.id}
                to={`/detail/${anime.id}`}
                className="group w-[152px] shrink-0 snap-start sm:w-[172px] md:w-[190px]"
              >
                <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg bg-background-200">
                  <img
                    src={anime.cover}
                    alt={`${anime.title} 封面`}
                    title={`${anime.title} - 最新更新`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent px-2.5 pb-2 pt-8">
                    <span className="font-label text-[11px] text-background-100">{anime.updateText}</span>
                  </div>
                  <span className="absolute left-2 top-2 rounded bg-primary-500 px-1.5 py-0.5 font-label text-[10px] text-background-50">
                    {anime.status}
                  </span>
                </div>
                <h3 className="mt-2.5 line-clamp-1 text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
                  {anime.title}
                </h3>
                <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
                  第 {anime.currentEpisode} 集 · {anime.genres[0]}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}